var map = {
	"./../active-quizzes/active-quizzes.module": [
		"./src/app/members/active-quizzes/active-quizzes.module.ts",
		"active-quizzes-active-quizzes-module"
	],
	"./../admin/admin.module": [
		"./src/app/members/admin/admin.module.ts",
		"admin-admin-module"
	],
	"./../admin/packages/create-package/create-package.module": [
		"./src/app/members/admin/packages/create-package/create-package.module.ts",
		"create-package-create-package-module"
	],
	"./../answer-questions/answer-questions.module": [
		"./src/app/members/answer-questions/answer-questions.module.ts",
		"answer-questions-answer-questions-module"
	],
	"./../attended-quizzes/attended-quizzes.module": [
		"./src/app/members/attended-quizzes/attended-quizzes.module.ts",
		"attended-quizzes-attended-quizzes-module"
	],
	"./../create-quiz-desktop/create-quiz-desktop.module": [
		"./src/app/members/create-quiz-desktop/create-quiz-desktop.module.ts",
		"create-quiz-desktop-create-quiz-desktop-module"
	],
	"./../dashboard/dashboard.module": [
		"./src/app/members/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./../profile/change-name/change-name.module": [
		"./src/app/members/profile/change-name/change-name.module.ts",
		"profile-change-name-change-name-module"
	],
	"./../profile/profile.module": [
		"./src/app/members/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./../profile/settings/settings.module": [
		"./src/app/members/profile/settings/settings.module.ts",
		"profile-settings-settings-module"
	],
	"./../profile/student-settings-page/student-settings-page.module": [
		"./src/app/members/profile/student-settings-page/student-settings-page.module.ts",
		"profile-student-settings-page-student-settings-page-module"
	],
	"./../quiz-report/quiz-report.module": [
		"./src/app/members/quiz-report/quiz-report.module.ts",
		"quiz-report-quiz-report-module"
	],
	"./../quiz-result/quiz-result.module": [
		"./src/app/members/quiz-result/quiz-result.module.ts",
		"quiz-result-quiz-result-module"
	],
	"./../quizes-report/quizes-report.module": [
		"./src/app/members/quizes-report/quizes-report.module.ts",
		"quizes-report-quizes-report-module"
	],
	"./../quizzes/quizzes.module": [
		"./src/app/members/quizzes/quizzes.module.ts",
		"quizzes-quizzes-module"
	],
	"./../search-member/search-member.module": [
		"./src/app/members/search-member/search-member.module.ts",
		"search-member-search-member-module"
	],
	"./../shared-quizzes/shared-quizzes.module": [
		"./src/app/members/shared-quizzes/shared-quizzes.module.ts",
		"shared-quizzes-shared-quizzes-module"
	],
	"./../subscribe-term/subscribe-term.module": [
		"./src/app/members/subscribe-term/subscribe-term.module.ts",
		"subscribe-term-subscribe-term-module"
	],
	"./../term/term.module": [
		"./src/app/members/term/term.module.ts",
		"term-term-module"
	],
	"./../terms/terms.module": [
		"./src/app/members/terms/terms.module.ts",
		"terms-terms-module"
	],
	"./packages/packages.module": [
		"./src/app/members/admin/packages/packages.module.ts",
		"packages-packages-module"
	],
	"./users/users.module": [
		"./src/app/members/admin/users/users.module.ts",
		"users-users-module"
	],
	"src/app/members/l/l.module": [
		"./src/app/members/l/l.module.ts",
		"src-app-members-l-l-module"
	],
	"src/app/members/member-routing.module": [
		"./src/app/members/member-routing.module.ts",
		"src-app-members-member-routing-module"
	],
	"src/app/members/profile/student-settings-page/student-settings-page.module": [
		"./src/app/members/profile/student-settings-page/student-settings-page.module.ts",
		"profile-student-settings-page-student-settings-page-module"
	],
	"src/app/public/forget-password/forget-password.module": [
		"./src/app/public/forget-password/forget-password.module.ts",
		"src-app-public-forget-password-forget-password-module"
	],
	"src/app/public/login/login.module": [
		"./src/app/public/login/login.module.ts",
		"src-app-public-login-login-module"
	],
	"src/app/public/register/register.module": [
		"./src/app/public/register/register.module.ts",
		"src-app-public-register-register-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;